import { defineTask } from "@nova/webworker-pool"
import { decodePng16Bit } from "./decodePng16Bit"
import { encodeTiff } from "./encodeTiff"
import type { MmaCsvRow } from "./parseMmaCsv"

export const convertPngWithCsv = defineTask({
    name: "convertPngWithCsv",
    run: async ({ buffer, csvRow }: { buffer: ArrayBuffer; csvRow: MmaCsvRow }) => {
        try {
            const { width, height, data } = decodePng16Bit(buffer)
            const tiffBuffer = encodeTiff(data, width, height, csvRow)
            return {
                data: { tiffBuffer, extension: "tiff", mimeType: "image/tiff" },
                transfer: [tiffBuffer],
            }
        } catch (error) {
            console.warn("convertPngWithCsv: failed", error)
            return { data: undefined }
        }
    },
})
